module.exports = __webpack_public_path__ + "img/30.d1a51534.png";